<template>
    <el-row type="flex">
      <el-col>
        <i v-if="hasEvent" class="fa fa-exclamation-triangle" :style="`color:${eventColor}`"/>
        &nbsp;
        {{ convertPerfData() }}
      </el-col>
    </el-row>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';

export default {
  name: 'WRscPerfEventTextLabel',
  props: {
    perfRecords: {
      type: Object,
    },
    perfKey: {
      type: String,
    },
  },

  data() {
    return {
      eventColor: '#5a9ee4',
      hasEvent: false,
    };
  },
  methods: {
    convertPerfData() {
      const perfRecords = this.perfRecords;
      const perfKey = this.perfKey;
      const perfData = perfRecords[perfKey];
      if (isNil(perfData)) {
        return EMPTY_TEXT;
      }
      const unit = perfRecords[`${perfKey}/UNIT`];
      return convertValuByUnit(perfData, unit, true);
    },
  },
  watch: {
    perfRecords: {
      immediate: true,
      handler(value) {
        const eventInfo = this.$store.getters.eventlevelInfo;
        const perfRecords = value;
        const key = this.perfKey;
        const eventLevelId = perfRecords[`${key}/EVENTLEVEL_ID`];

        if (isNil(eventLevelId)) {
          this.hasEvent = false;
        } else {
          this.hasEvent = !(eventLevelId === 'NM');
          if (!isEmpty(eventInfo[eventLevelId])) {
            this.eventColor = eventInfo[eventLevelId].eventlevelColorBg;
          }
        }
      },
    },
  },
  // updated() { // NOTE: Ju (DBMS_CODE_REVIEW) updated hook에서 이벤트 스티일 관련 처리 하는 이유?
  //   const eventInfo = this.$store.getters.eventlevelInfo;
  //   const perfRecords = this.perfRecords;
  //   const key = this.perfKey;
  //   const eventLevelId = perfRecords[`${key}/EVENTLEVEL_ID`];
  //
  //   if (isNil(eventLevelId)) {
  //     this.hasEvent = false;
  //   } else {
  //     this.hasEvent = !(eventLevelId === 'NM');
  //     if (!isEmpty(eventInfo[eventLevelId])) {
  //       this.eventColor = eventInfo[eventLevelId].eventlevelColorBg;
  //     }
  //   }
  // },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/textLabel/RscPerfEventTextLabel.vue